<template>
  <div class="container">
    <div class="title">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>平台建设</el-breadcrumb-item>
        <el-breadcrumb-item>服务中心</el-breadcrumb-item>
        <el-breadcrumb-item>语音服务</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="title-en">搜索条件</div>
    <el-card class="box-card">
      <div class="search-container">
        <el-form :inline="true" :model="searchForm" class="search-form" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="区域园区">
                <el-select clearable v-model="searchForm.idcpName" placeholder="请选择" @focus="handleSelectFocus">
                  <el-option v-for="(item, index) in campusOptions" :key="index" :label="Object.values(item)[0]"
                    :value="Object.values(item)[0]"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工作工单">
                <el-input v-model="searchForm.ticketId" placeholder="请输入工作工单"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="被叫电话">
                <el-input v-model="searchForm.callee" placeholder="请输入电话"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="呼叫状态">
                <el-select v-model="searchForm.state" placeholder="请选择" clearable>
                  <el-option label="接通" value="0"></el-option>
                  <el-option label="未接通" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="拨打时间">
                <el-date-picker v-model="searchForm.createTime" type="daterange" range-separator="-" style="width: 100%"
                  start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="handleDateChange">
                </el-date-picker>
              </el-form-item>
            </el-col>

          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="search-button">
                <el-button type="primary" @click="handleSearch">点击查询</el-button>
                <el-button @click="handleReset">重置</el-button>
                <el-button @click="debouncedExport">{{ exportButtonText }}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <div class="title-en">语音服务列表</div>
    <el-card class="box-card">
      <div class="table-container">
        <div class="button-container">
          <!-- 这里加一个总费用：变量all_fee在表格左上角 -->
           <div class="button-left">查询时间对应总费用：{{ all_fee }}元 --- 接通率：{{ accept_rate }}%</div>
          <div class="button-right">
            <el-button @click="openColumnsDialog">表头设置</el-button>
          </div>
        </div>

        <el-table :data="faults" border stripe @selection-change="handleSelectionChange" ref="table"
          v-loading="loading">
          <el-table-column v-for="(column, index) in visibleColumns" :key="index" :prop="column.prop"
            :label="column.label" :width="column.width" align="center" :fixed="column.fixed">
            <template slot-scope="scope">

              <span v-if="column.prop === 'reCallStatus'">
                <span v-if="scope.row.reCallStatus === '1'">已重播</span>
                <span v-else>{{ scope.row.reCallStatus || '-' }}</span>
              </span>
              <span v-else-if="column.prop === 'state'">
                <i v-if="scope.row.state === '0'" class="el-icon-phone-outline"
                  style="color: green;font-size: 40px;"></i>
                <i v-else-if="scope.row.state === '1'" class="el-icon-phone" style="color: red;font-size: 40px;"></i>
                <span v-else-if="column.prop === 'createTime'">{{
                  scope.row[column.prop]
                    ? $moment(scope.row[column.prop]).format('YYYY-MM-DD HH:mm:ss')
                    : '-'
                }}</span>
                <span v-else>{{ scope.row.state || '-' }}</span>
              </span>
              <span v-else>{{ scope.row[column.prop] || '-' }}</span>
            </template>
          </el-table-column>

        </el-table>

        <el-dialog title="设置显示项" :visible.sync="showColumnsDialog" :append-to-body="true" width="400px"
          :close-on-click-modal="false" custom-class="columns-dialog" :modal-append-to-body="false"
          :destroy-on-close="true">
          <el-checkbox-group v-model="selectedColumns" class="checkbox-group">
            <el-checkbox v-for="column in columns" :key="column.prop" :label="column.prop" class="checkbox-item">
              {{ column.label }}
            </el-checkbox>
          </el-checkbox-group>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="selectAllColumns">全选</el-button>
            <el-button size="small" @click="restoreDefaultColumns">恢复默认</el-button>
            <el-button size="small" type="primary" @click="saveColumnsDialog">保存</el-button>
          </div>
        </el-dialog>

        <div class="pagination-container">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { voiceFeedbackList } from '@/api/auto_dispatch';
import * as XLSX from 'xlsx';
import { debounce } from 'lodash';
import { getCampusList } from '@/api/operation';
export default {
  name: 'FaultList',
  data() {
    return {
      showColumnsDialog: false,
      campusOptions: [], // 用于存储园区接口返回的数据
      hasLoaded: false, // 添加标志位防止重复加载
      columns: [
        { prop: 'opTicketid', label: '鸿云内部PO单号', width: 150 },
        { prop: 'orderNo', label: 'PO订单号', width: 150 },
        { prop: 'ticketId', label: '待办工单号', width: 150 },
        { prop: 'state', label: '呼叫结果' },
        { prop: 'fee', label: '产生的费用(元)' },
        { prop: 'callee', label: '被叫号码', width: 150 },
        { prop: 'sendTime', label: '拨打时间', width: 150 },
        { prop: 'disconnectMsg', label: '通话结束原因', width: 150 },
        { prop: 'idcpName', label: '一级机房', width: 150 },
        { prop: 'svrItem', label: '专项(服务项)', width: 150 },
        { prop: 'serviceInfo', label: '服务信息', width: 300 },
        { prop: 'callId', label: '通话唯一标识', width: 150 },
        { prop: 'callTime', label: '通话时长' },
        { prop: 'timestamp', label: '回调时间戳' },
        { prop: 'userData', label: '用户透传数据' },
        { prop: 'callConStatus', label: '播打后状态' },
        { prop: 'reCallStatus', label: '重播状态' }
      ],
      selectedColumns: [
        'opTicketid',
        'orderNo',
        'ticketId',
        'idcpName',
        'svrItem',
        'serviceInfo',
        'callId',
        'callee',
        'callTime',
        'state',
        'fee',
        'timestamp',
        'userData',
        'disconnectMsg',
        'sendTime',
        'callConStatus',
        'reCallStatus'
      ],
      defaultSelectedColumns: [
        'opTicketid',
        'orderNo',
        'ticketId',
        'idcpName',
        'svrItem',
        'serviceInfo',
        'callId',
        'callee',
        'callTime',
        'state',
        'fee',
        'timestamp',
        'userData',
        'disconnectMsg',
        'sendTime',
        'callConStatus',
        'reCallStatus'
      ],
      visibleColumns: [],
      selectedRows: [],
      faults: [],
      searchForm: {
        createTime: [],
        ticketId: "",
        opTicketid: "",
        idcpName: "",
        callee: "",
        state: ""
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
    };
  },
  created() {
    this.visibleColumns = this.columns.filter((column) =>
      this.selectedColumns.includes(column.prop)
    );
    const now = new Date();
    const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
    const endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    this.searchForm.createTime = [
      this.$moment(startDate).format('YYYY-MM-DD'),
      this.$moment(endDate).format('YYYY-MM-DD'),
    ];
    this.handleDateChange(this.searchForm.createTime);

    // 初始化园区数据
    this.getCampusData();
    this.fetchFaultData();
    // 创建防抖后的导出函数
    this.debouncedExport = debounce(this.handleExport, 300);
  },
  methods: {
    //园区获取数据接口
    async getCampusData() {
      try {
        const params = {
          spec_sign: 1,
        };
        const response = await getCampusList(params);
        if (response.data && response.data.code === 200) {
          this.campusOptions = response.data.data;
          this.hasLoaded = true;
          //console.log("成功设置 campusOptions:", this.campusOptions)
        } else {
          console.warn("接口返回状态码不正确:", response.data?.code)
        }
      } catch (error) {
        console.error('获取园区数据失败:', error);
      }
    },

    // focus 事件处理园区获取数据
    handleSelectFocus() {
      if (!this.hasLoaded) {
        this.getCampusData();
      }
    },
    handleDateChange(dates) {
      if (dates) {
        this.searchForm.start_time = dates[0];
        this.searchForm.end_time = dates[1] + ' 23:59:59';
      } else {
        this.searchForm.start_time = '';
        this.searchForm.end_time = '';
      }
    },
    async fetchFaultData() {
      this.loading = true;
      const params = {
        page: this.currentPage,
        size: this.pageSize,
        ...Object.fromEntries(
          Object.entries(this.searchForm).filter(
            ([_, value]) => value !== '' && value !== null && value !== undefined
          )
        ),
      };
      // 处理日期范围
      if (this.searchForm.createTime && this.searchForm.createTime.length === 2) {
        params.start_time = this.searchForm.createTime[0];
        params.end_time = this.searchForm.createTime[1];
      }

      // 删除 finishedTime 避免传递给后端
      delete params.finishedTime;
      try {
        let response;
        // 添加结束时间的时分秒
        if (params.end_time) {
          params.end_time = params.end_time + ' 23:59:59';
        }
        // 使用常规的getPoList进行查询
        response = await voiceFeedbackList(params);

        if (response.data) {
          let filteredData = response.data.data || [];
          this.all_fee = response.data.all_fee;
          this.accept_rate = response.data.accept_rate;
          this.faults = filteredData;
          this.total = response.data.total || 0;
        }
      } catch (error) {
        console.error('请求错误:', error);
        let errorMessage = '获取数据失败';
        if (error.response && error.response.status === 422) {
          errorMessage = '请求参数格式不正确，请检查输入';
        }
        this.$message.error(errorMessage);
      } finally {
        this.loading = false;
      }
    },

    handleSearch() {
      this.currentPage = 1;
      this.fetchFaultData();
    },
    handleReset() {
      const now = new Date();
      const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
      const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

      this.searchForm = {
        id: null,
        ticketId: "",
        opTicketid: "",
        idcpName: "",
        callee: "",
        state: "",
        finishedTime: [
          this.$moment(firstDay).format('YYYY-MM-DD'),
          this.$moment(lastDay).format('YYYY-MM-DD'),
        ],
        start_time: this.$moment(firstDay).format('YYYY-MM-DD 00:00:00'),
        end_time: this.$moment(lastDay).format('YYYY-MM-DD 23:59:59') // 自动加上23:59:59
      };
      this.currentPage = 1;
      this.fetchFaultData();
    },

    async handleExport() {
      if (this.exportLoading) return;
      this.exportLoading = true;

      try {
        if (this.selectedRows.length === 0) {
          // 导出全部数据
          const params = {
            ...Object.fromEntries(
              Object.entries(this.searchForm).filter(
                ([key, value]) =>
                  value !== '' && value !== null && value !== undefined && key !== 'finishedTime'
              )
            ),
          };

          params.export_excel = "1";

          // 正确等待API响应
          const response = await voiceFeedbackList(params);

          if (response && response.data && response.data.code === 200) {
            const allData = response.data.data || [];

            if (allData.length === 0) {
              this.$message.warning('没有数据可导出');
              return;
            }

            // 处理并导出数据...
            const worksheetData = allData.map((row) => {
              const rowData = {};
              this.columns.forEach((column) => {
                if (column.prop !== 'operation') {
                  let value = row[column.prop];
                  if (column.prop === 'finished_time' && value) {
                    value = this.$moment(value).format('YYYY-MM-DD HH:mm:ss');
                  }
                  rowData[column.label] = value || '-';
                }
              });
              return rowData;
            });

            // 创建并导出Excel文件...

            const sheetName = '自动派单数据列表';
            const worksheet = XLSX.utils.json_to_sheet(worksheetData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
            const timestamp = this.$moment().format('YYYYMMDDHHmmss');
            const filename = `自动派单数据列表_${timestamp}.xlsx`;
            XLSX.writeFile(workbook, filename);
            this.$message.success('导出成功');
          } else {
            this.$message.error(response.data.msg || '导出失败');
          }
        }
        // ...处理选中行导出的逻辑
      } catch (error) {
        console.error('导出错误:', error);
        this.$message.error('导出失败，请重试');
      } finally {
        this.exportLoading = false;
      }
    },
    openColumnsDialog() {
      this.showColumnsDialog = true;
    },
    saveColumnsDialog() {
      this.showColumnsDialog = false;
      this.visibleColumns = this.columns.filter((column) =>
        this.selectedColumns.includes(column.prop)
      );
    },
    selectAllColumns() {
      this.selectedColumns = this.columns.map((column) => column.prop);
    },
    restoreDefaultColumns() {
      this.selectedColumns = [...this.defaultSelectedColumns];
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchFaultData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchFaultData();
    },
    handleViewDetail(row) {
      window.open(
        `https://dcops.fre.tencent-cloud.com/appManage/tickets/details?params=${row.opTicketid}`,
        '_blank'
      );
    },
  },
  computed: {
    exportButtonText() {
      return this.selectedRows.length > 0 ? `导出已选(${this.selectedRows.length})` : '导出全部';
    },
  },
};
</script>

<style scoped>
.button-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.button-left {
  flex: 1;
}

.button-right {
  flex-shrink: 0;
}

/* 可编辑单元格样式 */
.editable-cell {
  position: relative;
  cursor: pointer;
  min-height: 23px;
  padding: 2px 0;
}

.editable-text {
  position: relative;
  display: inline-block;
  padding: 2px 4px;
  border-radius: 2px;
  transition: all 0.3s;
  color: #409eff;
  /* 设置字体为蓝色 */
}

.editable-text:hover {
  background-color: #f0f8ff;
  border: 1px dashed #409eff;
  box-shadow: 0 0 2px #409eff;
}

.editable-icon {
  margin-left: 5px;
  font-size: 12px;
  color: #409eff;
  opacity: 0;
  transition: opacity 0.3s;
}

.editable-text:hover .editable-icon {
  opacity: 1;
}

/* 编辑状态下的输入框样式 */
.editable-cell .el-input__inner {
  border: 1px solid #409eff;
  box-shadow: 0 0 2px #409eff;
}

/* 确保文本垂直居中 */
.editable-cell .el-input {
  vertical-align: middle;
}

.container {
  padding: 20px;
  min-height: 500px;
  /* 确保容器有最小高度 */
}

/* .container {
  padding: 20px;
} */

.ellipsis-text {
  display: inline-block;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}

.search-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.search-form {
  width: 100%;
}

.search-button {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 10px;
}

/* 调整表单项间距 */
.el-form-item {
  margin-bottom: 18px;
  display: flex;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.box-card {
  margin-bottom: 20px;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
}

.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}

.columns-dialog {
  margin-top: 0 !important;
  position: absolute !important;
  margin-left: 0 !important;
  top: 100% !important;
  left: 0 !important;
  transform: none !important;
}

.el-dialog__wrapper.columns-dialog {
  position: absolute !important;
  overflow: visible !important;
}

.checkbox-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.checkbox-item {
  margin-right: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dialog-footer {
  text-align: right;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}

.dialog-footer .el-button+.el-button {
  margin-left: 8px;
}

/* PO单号链接样式 */
::v-deep .el-table a {
  color: #409eff;
  text-decoration: none;
  font-weight: 500;
}

::v-deep .el-table a:hover {
  color: #66b1ff;
  text-decoration: underline;
  font-weight: 500;
}

/* 修改日期选择器宽度 */
::v-deep .el-date-editor.el-input__inner,
.el-date-editor--daterange.el-input__inner {
  width: 100% !important;
}

::v-deep .el-range-editor.el-input__inner {
  width: 100% !important;
}

::v-deep .el-date-editor .el-range-input {
  width: 66% !important;
}

::v-deep .el-range-editor--small .el-range-input {
  font-size: 12px !important;
}

/* 统一下拉框和输入框宽度 */
::v-deep .el-select,
.el-input {
  width: 100% !important;
}

::v-deep .el-form-item__content {
  width: calc(100% - 30px) !important;
}

::v-deep .el-dialog .el-form-item__content {
  margin-left: 20px !important;
  /* 与 label-width 保持一致 */
}

::v-deep .el-dialog .el-form-item__label {
  text-align: left !important;
}
</style>
